import React from 'react'
import SliderGallery from '../components/SliderGallery'



const BronzeGallery = () => {

  const galleryImages = [

    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-24.jpg",
      alt:'Dec-Tec membrane in various applications and settings 1'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-3.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 2'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-4.jpg",
      alt:'Dec-Tec membrane in various applications and settings 3'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-2.jpg",
      alt:'Dec-Tec membrane in various applications and settings 4'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-1.jpg",
      alt:'Dec-Tec membrane in various applications and settings 5'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-23.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 6'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-21.jpg",
      alt:'Dec-Tec membrane in various applications and settings 7'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-20.jpg",
      alt:'Dec-Tec membrane in various applications and settings 8'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-19-rotated.jpg",
      alt:'Dec-Tec membrane in various applications and settings 9'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-18.jpg",
      alt:'Dec-Tec membrane in various applications and settings 10'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-17.jpg",
      alt:'Dec-Tec membrane in various applications and settings 11'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-16.jpg",
      alt:'Dec-Tec membrane in various applications and settings 12'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-15.jpg",
      alt:'Dec-Tec membrane in various applications and settings 13'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-14.jpg",
      alt:'Dec-Tec membrane in various applications and settings 14'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-13.jpg",
      alt:'Dec-Tec membrane in various applications and settings 15'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-14.jpg",
      alt:'Dec-Tec membrane in various applications and settings 16'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-12.jpg",
      alt:'Dec-Tec membrane in various applications and settings 17'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-5.jpg",
      alt:'Dec-Tec membrane in various applications and settings 18'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-11.jpg",
      alt:'Dec-Tec membrane in various applications and settings 19'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-10.jpg",
      alt:'Dec-Tec membrane in various applications and settings 20'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-9.jpg",
      alt:'Dec-Tec membrane in various applications and settings 21'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-10.jpg",
      alt:'Dec-Tec membrane in various applications and settings 22'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-8-rotated.jpg",
      alt:'Dec-Tec membrane in various applications and settings 23'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-10.jpg",
      alt:'Dec-Tec membrane in various applications and settings 24'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-7.jpg",
      alt:'Dec-Tec membrane in various applications and settings 25'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Bronze-6.jpg",
      alt:'Dec-Tec membrane in various applications and settings 26'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/iStock-175998824_bronze-edt.jpg",
      alt:'Dec-Tec membrane in various applications and settings 27'
    },
    // {
    //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_107481535_BRONZE-min.jpg",
    //   alt:'Dec-Tec membrane in various applications and settings 28'
    // },
   
  ]

  return (
    <div>
      <SliderGallery
        title="Bronze"
        para1="A neutral winner, Bronze is another hit with customers. Beautiful against brick and stucco and perfect for contrast against cool colors, this vinyl decking product is a clear winner."
        galleryImages={galleryImages}
        previouslink="/ashdown-gallery/"
        nextlink="/brick-gallery/"
      />
    </div>
  )
}

export default BronzeGallery
